import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import "./sideMenu.css";

const SideMenu = ({ client }) => {
  const [open, setOpen] = useState(false);

  const menuItems = [
    { label: "Dashboard", path: `dashboard` },
    { label: "Calendar", path: `bookings` },
    { label: "Expenses", path: `expenses` },
    { label: "BookKeeping", path: `bookkeeping` },
    { label: "User View", path: `/${client.id}` },
  ];

  return (
    <>
      <button
        type="button"
        className="side-menu-toggle"
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        {open ? <X size={22} /> : <Menu size={22} />}
      </button>

      {open && (
        <div
          className="side-menu-backdrop"
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
      )}

      <aside className={`side-menu-drawer ${open ? "open" : ""}`}>
        <div className="side-menu-brand">{client.companyName}</div>
        <nav className="side-menu-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="side-menu-link"
              onClick={() => setOpen(false)}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default SideMenu;
